import axios from 'axios'
import notifService from '@/services/notifService'
import { smsSignin } from '@/services/apiUser'

export const SIGNIN = async ({ commit }, credentials) => {
  return await axios
    .post('/auth/signin', credentials)
    .then(response => {
      localStorage.setItem('token', response.data.data.access_token.token)
      commit('SIGNIN', response.data)
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const SMS_SIGNIN = async ({ commit }, token) => {
  let res = await smsSignin(token)

  if (res) {
    localStorage.setItem('token', res.data.access_token)
    commit('SIGNIN', res.data)
    return 'ok'
  } else {
    notifService.notif('apiRes', res.message, 'error')
    return false
  }
}

export const SIGNOUT = async ({ commit }, _credentials) => {
  await axios
    .get('/auth/signout')
    .then(_response => {
      return true
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }

      return false
    })

  commit('SIGNOUT')
  localStorage.removeItem('token')
  localStorage.removeItem('cms')
}

export const ME = async ({ commit }) => {
  await axios
    .get('/auth/me')
    .then(response => {
      commit('updateUser', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const APP_VERSION = async _context => {
  await axios
    .get('/app')
    .then(resp => {
      const fe = resp.data.data.version_code ?? 'default'
      if (fe != localStorage.getItem('frontend')) {
        localStorage.setItem('frontend', fe)
        window.location.reload(true)
      }
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const UPDATE_PASSWORD = async (_context, data) => {
  return await axios
    .post('/auth/password/update', data)
    .then(response => {
      notifService.notif('apiRes', 'Success update password, silahkan login ulang.', 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return error
    })
}

export const FCM_TOKEN = (context, data) => {
  context.commit('FCM_TOKEN', data)
}
